export type ChecklistCardProps = {
	label: string;
	checked: boolean;
	setChecked: (val: boolean) => void;
};

const ChecklistCard = ({ label, checked, setChecked }: ChecklistCardProps) => (
	<div
		style={{
			width: '100%',
			height: 68,
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			borderRadius: 8,
			overflow: 'hidden',
			border: '1px solid',
			borderColor: checked ? 'var(--np-primary-color)' : '#C7CFD7',
			backgroundColor: checked ? 'var(--np-primary-color)' : 'white',
		}}
	>
		<div
			style={{
				width: 50,
				height: '100%',
				backgroundColor: checked ? 'var(--np-primary-color)' : '#C7CFD7',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
		</div>
		<div
			style={{
				width: '100%',
				height: '100%',
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				backgroundColor: checked ? '#EDF0F7' : 'white',
				padding: 8,
			}}
		>
			<span style={{ fontWeight: checked ? 700 : 500 }}>{label}</span>
		</div>
	</div>
);

export default ChecklistCard;
